/**
 * Leye Studio — display-only currency converter.
 * Converts visible NGN prices to an approximate USD / GBP / CAD amount for browsing.
 * Checkout still runs in NGN via Paystack — this does NOT change what a customer is charged.
 * Rates are approximate mid-market rates set manually. Update RATES below periodically.
 */
(function () {
  var RATES = {
    NGN: { rate: 1, symbol: '\u20a6' },
    USD: { rate: 1 / 1362, symbol: '$' },
    GBP: { rate: 1 / 1831, symbol: '\u00a3' },
    CAD: { rate: 1 / 990, symbol: 'CA$' }
  };
  var STORAGE_KEY = 'leye_display_currency';
  var PRICE_SELECTOR = '.price-item, .totals__total-value, .cart-item__price-wrapper .money, .money';
  var observer = null;

  function getSavedCurrency() {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'NGN';
    } catch (e) {
      return 'NGN';
    }
  }

  function saveCurrency(code) {
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {}
  }

  function extractNgnAmount(el) {
    if (el.dataset.ngnAmount) {
      return parseFloat(el.dataset.ngnAmount);
    }
    var text = el.textContent || '';
    var match = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var amount = parseFloat(match);
    if (isNaN(amount)) return null;
    el.dataset.ngnAmount = amount;
    el.dataset.ngnOriginal = text.trim();
    return amount;
  }

  function formatAmount(amount, currency) {
    var info = RATES[currency];
    var converted = amount * info.rate;
    var formatted = converted.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return info.symbol + formatted;
  }

  // Disconnects the observer while we edit the DOM so our own edits don't
  // trigger the observer again (which previously caused an infinite loop).
  function applyCurrency(currency) {
    if (observer) observer.disconnect();

    var elements = document.querySelectorAll(PRICE_SELECTOR);
    elements.forEach(function (el) {
      if (el.closest('#leye-currency-selector')) return;
      var amount = extractNgnAmount(el);
      if (amount === null) return;
      var nextText;
      if (currency === 'NGN' && el.dataset.ngnOriginal) {
        nextText = el.dataset.ngnOriginal;
      } else {
        nextText = formatAmount(amount, currency);
      }
      if (el.textContent !== nextText) {
        el.textContent = nextText;
      }
    });

    if (observer) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function init() {
    var current = getSavedCurrency();

    var trigger = document.getElementById('leye-currency-trigger');
    var panel = document.getElementById('leye-currency-panel');
    var flagEl = document.getElementById('leye-currency-flag');
    var labelEl = document.getElementById('leye-currency-label');
    var options = document.querySelectorAll('.leye-currency-option');

    options.forEach(function (opt) {
      if (opt.dataset.currency === current) {
        if (flagEl) flagEl.textContent = opt.dataset.flag;
        if (labelEl) labelEl.textContent = opt.dataset.label;
      }
      opt.addEventListener('click', function () {
        var chosen = opt.dataset.currency;
        saveCurrency(chosen);
        applyCurrency(chosen);
        if (flagEl) flagEl.textContent = opt.dataset.flag;
        if (labelEl) labelEl.textContent = opt.dataset.label;
        if (panel) panel.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    });

    if (trigger && panel) {
      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isHidden = panel.hidden;
        panel.hidden = !isHidden;
        trigger.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!panel.hidden && !panel.contains(e.target) && e.target !== trigger) {
          panel.hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Only re-apply on DOM changes that add brand new price elements
    // (e.g. cart drawer opening), never as a reaction to our own edits above.
    observer = new MutationObserver(function (mutations) {
      var hasNewPriceEl = false;
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && (node.matches(PRICE_SELECTOR) || node.querySelector(PRICE_SELECTOR))) {
            hasNewPriceEl = true;
          }
        });
      });
      if (hasNewPriceEl) {
        var currency = getSavedCurrency();
        if (currency !== 'NGN') applyCurrency(currency);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    applyCurrency(current);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
